<template>
  <IQOS :systemDependency="'delivery'" :enabled="is_active" :title="$t('delivery.min_check.title')">
    <p class="iqos-comment qrw-paragraph-md mt-16" v-if="!is_active">
      {{ $t("delivery.min_check.off_desc") }}
    </p>
    <!-- <BaseInput class="w-100" readonly :value="`${min_check} ${currency.code}`" v-if="!editing"/> -->
    <BaseUnitInput
      class="w-100 mt-16"
      fullWidth
      @blur="onEditFinish"
      type="number"
      :valid="!!min_check"
      v-model.number="min_check"
      :unitPlaceholder="currency.symbol"
      v-if="is_active"
    />

    <p class="iqos-comment qrw-paragraph-md mt-16" v-if="is_active">
      {{ $t("delivery.min_check.on_desc") }}
    </p>
    <template #actions>
      <IQOSToggle v-model="is_active" />
    </template>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import IQOSToggle from "@/components/IQOSToggle.vue";

import BlackInput from "@/components/BlackInput.vue";

export default {
  data() {
    return {
      editing: false,

      min_check: 0,

      is_active: false,
    };
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    IQOSToggle,
  },
  watch: {
    is_active() {
      if (!this.is_active) {
        this.min_check = 0;
        this.onEditFinish();
      }
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.setInitialValue();
    },
    onEditFinish() {
      this.$store.commit("setDeliveryMinCheck", this.min_check);
      this.$store.dispatch("saveCafe");

      // this.editing = false;
    },
    setInitialValue() {
      if (this.cafe.delivery.min_check) {
        this.min_check = this.cafe.delivery.min_check;
      } else {
        this.min_check = 0;
      }

      this.is_active = this.min_check > 0;
    },
  },
  mounted() {
    this.setInitialValue();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
  },
};
</script>

<style scoped>
</style>